import { cn } from '../../lib/utils';

export type DefaultAvatarProps = {
  name: string;
  seed?: string | null;
  className?: string;
  /** @deprecated Abstract avatars no longer render initials; kept for call-site compatibility. */
  textClassName?: string;
};

const PALETTES = [
  ['#D7E2DF', '#4D5A70', '#FFFFFF'],
  ['#FFE2D4', '#E96B56', '#FFF8F0'],
  ['#DCE7FF', '#5572D8', '#F8FAFF'],
  ['#E5F6DB', '#4E9D6D', '#FAFFF7'],
  ['#F4DFF0', '#9D5AA2', '#FFF8FD'],
  ['#F8E7B8', '#C6862A', '#FFFDF4'],
  ['#D8F2F3', '#248D99', '#F7FFFF'],
  ['#E6E1FF', '#6753B8', '#FBFAFF'],
] as const;

function hashSeed(seed: string) {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return hash;
}

export function DefaultAvatar({ name, seed, className }: DefaultAvatarProps) {
  const value = seed || name || 'member';
  const hash = hashSeed(value);
  const [bg, shape, face] = PALETTES[hash % PALETTES.length]!;
  const rotate = (hash % 24) - 12;
  const offset = (hash % 9) - 4;

  return (
    <span className={cn('relative flex size-full overflow-hidden rounded-full', className)} aria-hidden="true">
      <span className="absolute inset-0" style={{ backgroundColor: bg }} />
      <span
        className="absolute -bottom-[18%] left-1/2 h-[58%] w-[92%] -translate-x-1/2 rounded-[50%_50%_0_0]"
        style={{ backgroundColor: shape, transform: `translateX(-50%) rotate(${rotate}deg)` }}
      />
      <span
        className="absolute left-1/2 top-[19%] size-[52%] -translate-x-1/2 rounded-full border border-black/10 shadow-sm"
        style={{ backgroundColor: face, transform: `translateX(calc(-50% + ${offset}px))` }}
      />
      <span className="absolute left-[43%] top-[34%] size-[4%] rounded-full bg-slate-700" />
      <span className="absolute left-[57%] top-[32%] size-[4%] rounded-full bg-slate-700" />
      <span className="absolute left-[50%] top-[45%] h-[9%] w-[16%] -translate-x-1/2 rounded-b-full border-b-2 border-slate-700/70" />
    </span>
  );
}
